// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import Dropdown from 'common/components/ui/Dropdown';
import type { DateRangePeriod } from '../../../domain/MetricsPeriods';

const DropDownLabel = styled.span`
  color: ${props => props.theme.V3.colors.text.formLabel};      
  font-weight: bold;
  font-size: ${props => props.theme.V3.fonts.forms.label.size}px;
  letter-spacing: ${props => props.theme.V3.fonts.forms.label.letterSpacing}px;
  
  padding-right: ${props => props.theme.V3.metrics.margin.small}px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  padding-top: ${props => props.theme.V3.metrics.margin.normal}px;
  padding-bottom: ${props => props.theme.V3.metrics.margin.normal}px;
`;

const DropdownContainer = styled.div`
  width: 220px;
`;

interface Props {
  onChange: (DateRangePeriod) => void;
  onOpen: () => void;
  defaultValue: DateRangePeriod;
  t: any;
}

function DateRangePeriodSelector({ onChange, onOpen, defaultValue, t }: Props) {
  const periods = [
    { value: 'FULL_WEEK', label: `${t('allWeek')} ${t('allWeekSuffix')}` },
    { value: 'WEEK_DAYS', label: `${t('weekDays')} ${t('weekDaysSuffix')}` },
    { value: 'WEEKEND', label: `${t('weekend')} ${t('weekendSuffix')}` },
    { value: 'SINGLE_DAY', label: `${t('singleDay')}` },
  ];

  return (
    <Container>
      <DropDownLabel>{t('specifiedPeriod')}</DropDownLabel>
      <DropdownContainer>
        <Dropdown defaultValue={defaultValue} items={periods} onChange={onChange} onOpen={onOpen} />
      </DropdownContainer>
    </Container>
  );
}

export default translate()(DateRangePeriodSelector);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/DateRangePeriodSelector.js